var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.filterComponent,{ref:"innerFilter",tag:"component",attrs:{"pager":_vm.pager},on:{"change":_vm.onChange,"page-change":_vm.onPageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }